import { extendTheme, ThemeConfig } from '@chakra-ui/react';
import Button from './theme/button.recipe';

const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  components: {
    Button,
    Toast: {
      baseStyle: {
        container: {
          bg: 'gray.800',
          color: 'white',
          borderRadius: 'xl',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          border: '1px solid',
          borderColor: 'gray.700',
          backdropFilter: 'blur(10px)',
          p: 4,
          minW: '320px',
          maxW: '400px',
        },
        title: {
          fontWeight: '600',
          fontSize: 'md',
          color: 'white',
          mb: 1,
        },
        description: {
          color: 'gray.300',
          fontSize: 'sm',
          lineHeight: '1.4',
        },
        icon: {
          color: 'white',
        },
      },
      variants: {
        solid: (props: any) => ({
          container: {
            bg: props.status === 'success' ? 'green.500' : 
                props.status === 'error' ? 'red.500' : 
                props.status === 'warning' ? 'orange.500' : 
                props.status === 'info' ? 'blue.500' : 'gray.800',
            color: 'white',
            borderColor: props.status === 'success' ? 'green.400' : 
                        props.status === 'error' ? 'red.400' : 
                        props.status === 'warning' ? 'orange.400' : 
                        props.status === 'info' ? 'blue.400' : 'gray.700',
          },
          title: {
            color: 'white',
          },
          description: {
            color: 'whiteAlpha.900',
          },
          icon: {
            color: 'white',
          },
        }),
        subtle: (props: any) => ({
          container: {
            bg: props.status === 'success' ? 'green.50' : 
                props.status === 'error' ? 'red.50' : 
                props.status === 'warning' ? 'orange.50' : 
                props.status === 'info' ? 'blue.50' : 'gray.50',
            color: props.status === 'success' ? 'green.800' : 
                   props.status === 'error' ? 'red.800' : 
                   props.status === 'warning' ? 'orange.800' : 
                   props.status === 'info' ? 'blue.800' : 'gray.800',
            borderColor: props.status === 'success' ? 'green.200' : 
                        props.status === 'error' ? 'red.200' : 
                        props.status === 'warning' ? 'orange.200' : 
                        props.status === 'info' ? 'blue.200' : 'gray.200',
          },
        }),
        leftAccent: (props: any) => ({
          container: {
            borderLeft: '4px solid',
            borderLeftColor: props.status === 'success' ? 'green.500' : 
                            props.status === 'error' ? 'red.500' : 
                            props.status === 'warning' ? 'orange.500' : 
                            props.status === 'info' ? 'blue.500' : 'gray.500',
            bg: 'gray.800',
            color: 'white',
          },
        }),
        topAccent: (props: any) => ({
          container: {
            borderTop: '4px solid',
            borderTopColor: props.status === 'success' ? 'green.500' : 
                           props.status === 'error' ? 'red.500' : 
                           props.status === 'warning' ? 'orange.500' : 
                           props.status === 'info' ? 'blue.500' : 'gray.500',
            bg: 'gray.800',
            color: 'white',
          },
        }),
      },
      defaultProps: {
        variant: 'solid',
      },
    },
  },
});

export default theme;